<template>
  <header class="header-text">
    <div class="inner richtext-content">
      <h1 v-if="data.title" class="title" v-html="data.title" />
      <StructuredText v-if="data.lead" class="structured-text text lead" :data="data.lead" />
    </div>
  </header>
</template>

<script setup lang="ts">
import { StructuredText } from 'vue-datocms';
import type { HeaderTextFragment } from '#gql';

defineProps<{
  data: HeaderTextFragment;
}>();
</script>

<style scoped lang="scss">
.header-text {
  @include grid-layout();

  & {
    padding: var(--site-inner-padding);
    width: 100%;
    max-width: var(--site-max-width);
  }

  @media (--xs), (--sm) {
    margin-top: 5.5rem;
  }

  @media (--md), (--lg) {
    margin-top: 9.5rem;
  }

  > .inner {
    display: grid;
    gap: var(--spacing-xs);
    padding: var(--spacing-4xl) 0;
    max-width: 900px;

    @media (--xs), (--sm) {
      padding: var(--spacing-sm) 0;
    }

    @media (--xs) {
      gap: var(--spacing-2xs);
      grid-column: 1 / -1;
    }

    @media (--sm) {
      grid-column: 2 / 24;
    }

    @media (--md), (--lg) {
      grid-column: 5 / 21;
    }
  }
}
</style>
